import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { signOut } from '../../../helpers/auth';

@connect(state => ({
  local: state.local,
  user: state.memory.user,
}))

/**
 * Renders the header user section with username and logout button
 */
class Username extends Component {
  state = {};

  get username() {
    const { user } = this.props;
    if (user && user) {
      return `${user.lastName ?? ''} ${user.firstName ?? ''}`;
    }
    return '';
  }

  logout = e => {
    signOut();
  };

  /**
   * render
   * @return {ReactElement} markup
   */
  render() {
    if (isMobile) {
      return <></>;
    }
    return (
      <div className="header-user">
        <div className="username-display">
          {this.username}
        </div>
        <div className="logout-btn" onClick={this.logout}>
          ログアウト
        </div>
      </div>
    );
  }
}

Username.propTypes = {
  local: PropTypes.object,
};

export default Username;
